import { TCategory } from "../../../types"
import { publicApi } from "../../api"

export async function GetCategories(): Promise<TCategory[]> {
  const res = await publicApi.get<TCategory[]>("/category?per_page=1000")
  return res.data
}
